export default {"src":"/_next/static/media/logo-institut-francais.d0da4a3e.svg","height":69,"width":120};